<template>
  <div>
    <Col :md="{span: 12, offset: 6}">
      <Card shadow>
        <Alert type="error" show-icon v-if="errorMsg">{{ errorMsg }}</Alert>
        <Form :model="lForm" ref="lForm" :rules="lRules">
          <FormItem label="选择要登录的用户" prop="user_id">
            <Select v-model="lForm.user_id" filterable>
              <Option v-for="item in users" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="submit" :loading="submitting">登录</Button>
          </FormItem>
        </Form>
      </Card>
    </Col>
  </div>
</template>

<script>
import { GetALLUsers } from '@/api/user'
import { mapActions } from 'vuex'

export default {
  name: 'substitute-login',
  data () {
    return {
      users: [],
      lForm: {
        user_id: null
      },
      lRules: {
        user_id: { required: true, message: '请选择要登录的用户 !', trigger: 'change', type: 'number' }
      },
      submitting: false,
      errorMsg: null
    }
  },
  created: function () {
    if (!this.$store.state.user.superuser) {
      this.$router.push({name: this.$config.homeName})
    } else {
      this.getAllUsersData()
    }
  },
  methods: {
    ...mapActions([
      'substituteLogin'
    ]),
    // 获取所有用户列表
    getAllUsersData () {
      GetALLUsers().then(res => {
        this.users = res.data
      }).catch(res => {
        console.error(res.response)
      })
    },
    // 登录
    submit () {
      this.$refs.lForm.validate((valid) => {
        if (valid) {
          this.submitting = true
          this.errorMsg = null
          let userId = this.lForm.user_id
          this.substituteLogin({ userId }).then(res => {
            this.$Notice.success({
              title: '登录成功！'
            })
            this.$router.push({
              name: this.$config.homeName
            })
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            this.errorMsg = res.response.data
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
